import React, { useState } from "react";
import styled from "styled-components";
import PhotoManager from "./PhotoDashboard/PhotoManager";
import RecruitManager from "./RecruitDashboard/RecruitManager";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const Navigate = useNavigate();
  const [currentMenu, setCurrentMenu] = useState("photos");

  const onLogout = async () => {
    localStorage.clear();
    Navigate("/");
  };

  return (
    <Container>
      <Sidebar>
        <LogoSection>
          <h2>Admin Dashboard</h2>
        </LogoSection>
        <MenuSection>
          <MenuItem
            active={currentMenu === "photos"}
            onClick={() => setCurrentMenu("photos")}
          >
            홈페이지 게시판 관리
          </MenuItem>
          {/* <MenuItem
            active={currentMenu === "recruit"}
            onClick={() => setCurrentMenu("recruit")}
          >
            채용 공고 관리
          </MenuItem> */}
        </MenuSection>
        <LogoutBtn onClick={onLogout}>로그아웃</LogoutBtn>
      </Sidebar>

      {/* 메인 콘텐츠 영역 */}
      <MainContent>
        <Header>
          <h1>
            {currentMenu === "photos"
              ? "홈페이지 게시판 관리"
              : "채용 공고 관리"}
          </h1>
        </Header>
        <ContentBody>
          {currentMenu === "photos" ? <PhotoManager /> : <RecruitManager />}
        </ContentBody>
      </MainContent>
    </Container>
  );
};

export default Dashboard;

// --- Styled Components ---
const Container = styled.div`
  display: flex;
  height: 100vh;
  background-color: #f8f9fa;
`;

const Sidebar = styled.nav`
  width: 260px;
  background-color: #1e293b;
  color: white;
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
`;

const LogoSection = styled.div`
  margin-bottom: 3rem;
  padding-left: 1rem;
  h2 {
    font-size: 1.2rem;
    color: #38bdf8;
  }
  p {
    font-size: 0.8rem;
    color: #94a3b8;
  }
`;

const MenuSection = styled.div`
  flex: 1;
`;

const MenuItem = styled.div`
  padding: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${(props) => (props.active ? "#334155" : "transparent")};
  color: ${(props) => (props.active ? "#fff" : "#94a3b8")};
  transition: all 0.2s;
  &:hover {
    background-color: #334155;
    color: #fff;
  }
`;

const MainContent = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  background: white;
  padding: 1.5rem 3rem;
  border-bottom: 1px solid #e2e8f0;
  h1 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #0f172a;
  }
`;

const ContentBody = styled.div`
  padding: 3rem;
`;

const LogoutBtn = styled.button`
  background: #ef4444;
  color: white;
  border: none;
  padding: 0.8rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
`;
